module.exports = __webpack_public_path__ + "static/img/cancelorder.9004a49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/thank/cancelorder.png
// module id = RnmP
// module chunks = 1